const getCurrentDateFormat = () => {
    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    const monthName = currentDate.toLocaleDateString('es-MX', { month: 'long' }).toLowerCase();
    const Year = currentDate.getFullYear();
    const currentMonthText = `${firstDay.getDate()} al ${lastDay.getDate()} de ${monthName} del ${Year}`;
    return {
        firstDay,
        lastDay,
        monthName,
        currentMonthText
    };
};
export default getCurrentDateFormat;
